import { render, staticRenderFns } from "./FangkuaiSquare.vue?vue&type=template&id=5d27db67&"
import script from "./FangkuaiSquare.vue?vue&type=script&lang=js&"
export * from "./FangkuaiSquare.vue?vue&type=script&lang=js&"
import style0 from "./FangkuaiSquare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports